export const buildPaymentPlatformCopilotContext = (overview) => {
  if (!overview) return null;
  const job = overview.latestImport || {};
  const sample = Array.isArray(job.preview) ? job.preview.slice(0, 100) : [];
  const matched = Number(job.matchedEntities || 0);
  const assessed = Number(job.assessedEntities || 0);
  const status = job.status || "unknown";

  return {
    workspace: "MCA / Loan Assessments",
    dataScope: "Tenant payment-platform assessment data",
    tenant: overview.tenant,
    model: overview.model,
    portfolioSummary: {
      importStatus: status,
      importStage: job.stage || null,
      matchedMerchants: matched,
      assessedMerchants: assessed,
      unmatchedRows: Number(job.unmatchedRows || 0),
      decisionDistribution: job.decisionDistribution || {},
      riskDistribution: job.riskDistribution || {},
      aggregates: job.aggregates || {},
      validation: job.validation || overview.model?.validation || null,
    },
    assessmentSample: sample,
    coverageNote: [
      `This is a live ${status} import snapshot covering ${matched.toLocaleString()} matched and ${assessed.toLocaleString()} assessed merchants.`,
      "Use portfolioSummary aggregates for exact portfolio totals when populated.",
      sample.length
        ? `assessmentSample contains ${sample.length.toLocaleString()} representative records; never extrapolate whole-portfolio totals from it.`
        : "No row-level assessment sample is loaded; do not invent row-level or monetary totals that are absent from portfolioSummary.",
    ].join(" "),
  };
};
